import { API_URL, PRICE_SCHEME_HEADER } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IGetModifierGroupsParams, ItemModifierGroupsResponseBody } from './types';

export const getModifierGroups = async ({
  priceSchemeId,
  limit = 50,
  afterId,
  name,
  menus,
  pricingCategories,
  missingDefaultPrice,
  channels,
  priceBands,
}: IGetModifierGroupsParams): Promise<ItemModifierGroupsResponseBody> => {
  const url = new URL(`${API_URL}/items/modifier-groups?limit=${limit}`);

  if (afterId) url.searchParams.append('after_id', afterId);
  if (name) url.searchParams.append('name', name);
  if (menus?.length) url.searchParams.append('menus', menus.join(','));
  if (pricingCategories?.length) url.searchParams.append('pricing_categories', pricingCategories.join(','));
  if (missingDefaultPrice) url.searchParams.append('missing_default_price', 'true');
  if (channels?.length) url.searchParams.append('channels', channels.join(','));
  if (priceBands?.length) url.searchParams.append('price_bands', priceBands.join(','));

  try {
    const res = await fetch(url.toString(), {
      headers: {
        [PRICE_SCHEME_HEADER]: priceSchemeId,
      },
    });

    if (!res.ok) {
      throw new Error('We have been unable to complete your request. Please try again.');
    }

    const data: ItemModifierGroupsResponseBody = await res.json();
    return data;
  } catch (err) {
    throw new Error(err);
  }
};
